import {PaidGigDetails} from '@/types/paidGig';
import api from '@/api';

const PAID_GIGS_PATH = 'paid_gigs';
const DEFAULT_INCLUDES = ['brand_negotiation'];

const paidGigsFetchers = {
  details: async (paidGigId: string): Promise<PaidGigDetails> => {
    const result = await api.get(`${PAID_GIGS_PATH}/${paidGigId}`, {
      params: {
        include: DEFAULT_INCLUDES,
      },
    });

    return result.data as PaidGigDetails;
  },
};

export default paidGigsFetchers;
